import { doc, getDoc } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import { Cart, CartCollection, mapDocToCart } from "../types/Cart";

export function useSavedCart(cartId: string | undefined) {
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState<Cart | null>(null);

  useEffect(() => {
    const fetchCart = async () => {
      if (!cartId) {
        return;
      }

      setLoading(true);

      const cartRef = doc(firestore, CartCollection, cartId);
      const cartDoc = await getDoc(cartRef);
      if (cartDoc.exists()) {
        setCart(mapDocToCart(cartDoc.data()));
      }
      setLoading(false);
    };

    fetchCart();
  }, [cartId]);

  return useMemo(() => {
    return { cart, isLoading: loading };
  }, [cart, loading]);
}
